var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_92_3708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_92_3708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15382 21.5576C6.66794 21.5576 6.25481 21.3874 5.91442 21.0471C5.57404 20.7067 5.40385 20.2936 5.40385 19.8077C5.40385 19.3218 5.57404 18.9086 5.91442 18.5683C6.25481 18.2279 6.66794 18.0577 7.15382 18.0577C7.63972 18.0577 8.05287 18.2279 8.39325 18.5683C8.73363 18.9086 8.90382 19.3218 8.90382 19.8077C8.90382 20.2936 8.73363 20.7067 8.39325 21.0471C8.05287 21.3874 7.63972 21.5576 7.15382 21.5576ZM16.8461 21.5576C16.3602 21.5576 15.9471 21.3874 15.6067 21.0471C15.2663 20.7067 15.0961 20.2936 15.0961 19.8077C15.0961 19.3218 15.2663 18.9086 15.6067 18.5683C15.9471 18.2279 16.3602 18.0577 16.8461 18.0577C17.332 18.0577 17.7451 18.2279 18.0855 18.5683C18.4259 18.9086 18.5961 19.3218 18.5961 19.8077C18.5961 20.2936 18.4259 20.7067 18.0855 21.0471C17.7451 21.3874 17.332 21.5576 16.8461 21.5576ZM5.29613 4.25H19.1807C19.5897 4.25 19.899 4.42403 20.1086 4.7721C20.3182 5.12018 20.3281 5.47563 20.1384 5.83845L16.9346 11.6423C16.7705 11.9307 16.5535 12.1554 16.2836 12.3163C16.0137 12.4772 15.7179 12.5576 15.3961 12.5576H8.09998L6.94227 14.673C6.89099 14.75 6.88939 14.8333 6.93747 14.9231C6.98556 15.0128 7.05767 15.0577 7.15382 15.0577H18.5961V16.5576H7.15382C6.48717 16.5576 5.98622 16.2701 5.65095 15.6952C5.3157 15.1202 5.30384 14.5461 5.61538 13.9731L7.04233 11.4077L3.40385 3.74995H1.5V2.25H4.34612L5.29613 4.25Z",
    fill: "#1C1B1F"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.44a49ca2.svg";
export { ForwardRef as ReactComponent };